/**
 * An object that contains all colors in hex values.
 */
let colorsHex = {
    voltage: {
        l1: {
           border: '#8301FE',
        },
        l2: {
           border: '#B543F0',
        },
        l3: {
           border: '#43AFF0',
        },
        unit: '#6F6F6F'
    },
    temperature: {
        mean: {
            border: '#FF8500',
        },
        unit: '#6F6F6F'
    },
    humidity: {
        mean: {
            border: '#37BAFF',
        },
        unit: '#6F6F6F'
    },
    power: {
        import: {
            l1: {
                border: '#8500FF',
            },
            l2: {
                border: '#B543F0',
            },
            l3: {
                border: '#4349F0',
            },
        },
        export: {
            l1: {
                border: '#00D330',
            },
            l2: {
                border: '#1EE389',
            },
            l3: {
                border: '#96E523',
            },
        },
        unit: '#6F6F6F'
    },
    water: {
        import: {
            border: '#0094FF',
        },
        unit: '#6F6F6F'
    },
}

let colors = {
    gridLineColor: 'rgb(35,35,35)',
    power_import: {
        border: 'rgb(131,0,255)',
        gradient_start: 'rgba(196,0,255,0.9)',
        gradient_end: 'rgba(78,0,218,0.4)',
    },
    power_export: {
        border: 'rgb(0,211,48)',
        gradient_start: 'rgba(0,255,5,0.9)',
        gradient_end: 'rgba(0,194,175,0.4)',
    },

    // 'background graph' color
    power_import_standby: {
        gradient_start: 'rgba(196,0,255,0.4)',
        gradient_end: 'rgba(78,0,218,0.4)',
    },
    power_export_standby: {
        gradient_start: 'rgba(0,255,5,0.4)',
        gradient_end: 'rgba(0,194,175,0.4)',
    },

    // self consumption blue
    power_self_consumption: {
        border: 'rgb(0,183,255)',
        gradient_start: 'rgba(0,185,255,1)',
        gradient_end: 'rgba(16,119,134,1)',
    },

    // temperature mean orange
    temperature_mean: {
        border: 'rgb(255,113,0)',
        gradient_start: 'rgba(255,120,19,0.7)',
        gradient_end: 'rgba(58,111,255,0)',
    },

    // temperature min blue
    temperature_min: {
        border: 'rgb(58,149,255)',
        gradient_start: 'rgba(55,186,255,0.7)',
        gradient_end: 'rgba(26,1,255,0.1)',
    },

    // temperature max pink
    temperature_max: {
        border: 'rgb(255,0,114)',
        gradient_start: 'rgba(255,0,114,0.7)',
        gradient_end: 'rgba(58,149,255,0)',
    },

    // humidity mean blue
    humidity_mean: {
        border: 'rgb(55,186,255)',
        gradient_start: 'rgba(19,147,241,0.5)',
        gradient_end: 'rgba(58,149,255,0)',
    },

    // humidity min white
    humidity_min: {
        border: 'rgb(255,255,255)',
        gradient_start: 'rgba(255,255,255,0.5)',
        gradient_end: 'rgba(255,255,255,0)',
    },

    // humidity max purple
    humidity_max: {
        border: 'rgb(170,0,254)',
        gradient_start: 'rgba(177,0,255,0.5)',
        gradient_end: 'rgba(58,194,255,0)',
    },

    // 3 phase colors
    power_import_l1: {
        border: 'rgb(131,1,254)',
        gradient_start: 'rgba(86,0,255,0.8)',
        gradient_end: 'rgba(156,0,230,0.3)',
    },
    power_export_l1: {
        border: 'rgb(0,211,48)',
        gradient_start: 'rgba(53,207,22,0.8)',
        gradient_end: 'rgba(22,207,100,0.3)',
    },
    power_import_l2: {
        border: 'rgb(181,67,240)',
        gradient_start: 'rgba(160,0,255,0.8)',
        gradient_end: 'rgba(72,0,255,0.3)',
    },
    power_export_l2: {
        border: 'rgb(30,227,137)',
        gradient_start: 'rgba(22,207,79,0.8)',
        gradient_end: 'rgba(22,207,163,0.3)',
    },
    power_import_l3: {
        border: 'rgb(67,73,240)',
        gradient_start: 'rgba(0,68,255,0.8)',
        gradient_end: 'rgba(0,68,255,0.3)',
    },
    power_export_l3: {
        border: 'rgb(150,229,35)',
        gradient_start: 'rgba(165,255,38,0.8)',
        gradient_end: 'rgba(38,255,88,0.3)',
    },

    gas_import: {
        border: 'rgb(255,0,113)',
        gradient_start: 'rgba(255,0,25,0.9)',
        gradient_end: 'rgba(185,0,228,0.3)',
    },

    water_import: {
        border: 'rgb(0,148,255)',
        gradient_start: 'rgba(49,145,255,0.9)',
        gradient_end: 'rgba(92,37,208,0.3)',
    },

    voltage: {
        l1_border: 'rgb(131, 1, 254)',
        l1_gradient_start: 'rgba(131, 1, 254, 0.15)',
        l1_gradient_end: 'rgba(131, 1, 254, 0.0)',
        l2_border: 'rgb(181, 67, 240)',
        l2_gradient_start: 'rgba(181, 67, 240, 0.15)',
        l2_gradient_end: 'rgba(181, 67, 240, 0.0)',
        l3_border: 'rgb(67, 175, 240)',
        l3_gradient_start: 'rgba(67, 175, 240, 0.15)',
        l3_gradient_end: 'rgba(67, 175, 240, 0.0)',
        limit_border: 'rgb(255, 255, 255)',
    },

    battery: {
        charge_pct: 'rgb(255, 255, 255)',
    },

    datalabels: 'rgb(255,255,255)',
    default_font: 'rgba(255,255,255,0.5)'
}

colors.hover = {
    import: colors.power_import.border,
    export: colors.power_export.border,
    gas: colors.gas_import.border,
    water: colors.water_import.border,
    self_consumption: colors.power_self_consumption.border,
    temperature_mean: colors.temperature_mean.border,
    temperature_min: colors.temperature_min.border,
    temperature_max: colors.temperature_max.border,
    humidity_mean: colors.humidity_mean.border,
    humidity_min: colors.humidity_min.border,
    humidity_max: colors.humidity_max.border,
    voltage_l1: colors.voltage.l1_border,
    voltage_l2: colors.voltage.l2_border,
    voltage_l3: colors.voltage.l3_border,
    voltage_limit: colors.voltage.limit_border,
    time: 'rgb(255,255,255)',
}

module.exports.colors = colors
module.exports.colorsHex = colorsHex